import api from "../../api";
import {promptData} from "../../util/MessageTools";
import {dateStr2Timestamp} from "../../util/TimeTransition";
import {userTypeEnumToString, checkEnumToString} from "../../util/EnumTransition";
import de from "element-ui/src/locale/lang/de";

export default {
  name: "thesisAllot",
  data() {
    return {
      data: [],
      tableLoading:false

    }
  },
  methods: {
    /**
     * 合计
     */
    getSummaries(param) {
      const {columns} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总人数';
          return;
        }
        if (index === 1) {
          sums[index] = "总 人 数 " + this.data.length + " 人";
        }
      });
      return sums;
    },

    /**
     * 合并单元格
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {number[]}
     */
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      //如果有要求合并单元格,就合并单元格
    },

  },

  created() {
    let vue = this
    vue.tableLoading = true
    api.user.getUserList("PLAYER").then(function (response) {
      vue.tableLoading = false
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        let result = response.data.result
        for (let i = 0; i < result.length; i++) {
          result[i].createTime = dateStr2Timestamp(result[i].createTime)
          result[i].lastLoginTime = dateStr2Timestamp(result[i].lastLoginTime)
          result[i].userTypeEnum = userTypeEnumToString(result[i].userTypeEnum)
          result[i].certificateStatus = checkEnumToString(result[i].certificateStatus)
        }
        vue.data = result
      }

    }).catch(err=>{
      vue.tableLoading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/PlayerManage.js